/**
 * Main Layout Component
 * Wraps all pages with navigation and footer
 * Following Material-UI marketing page template style
 */
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import NavigationMUI from './NavigationMUI';
import FooterMUI from './FooterMUI';

export default function Layout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavigationMUI />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          pt: { xs: '64px', md: '70px' }, // Account for fixed AppBar height
        }}
      >
        <Outlet />
      </Box>
      <FooterMUI />
    </Box>
  );
}
